import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { of } from 'rxjs';
import { metricsService } from '../../../common/services';

export function getMetrics(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_METRICS),
    mergeMap(({ payload }) => {
      return metricsService.getMetrics(payload).pipe(
        map((res) => actions.getMetricsSuccess(res.responceObject.records)),
        catchError((error) =>
          of({
            type: actionTypes.GET_METRICS_FAIL,
            payload: error,
            error: true
          }))
      )
    })
  )
}
